










































import { Component } from "vue-property-decorator";
import Base from "@/components/elements/products/Base.vue";
import Collections from "./Collections";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
@Component({
  components: {
    Base,
    AccordionSection
  }
})
export default class BaseMenu extends Collections {}
